import React, { useEffect, useRef } from "react";

export default function TicketModal({isOpen, onClose, submit, children}) {
  const modalRef = useRef();

  useEffect(() => {
    const handleMouseUp = (event) => {
      if (isOpen && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="fixed inset-0 bg-stone-950 bg-opacity-75"></div>
        </div>
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
        <div
          ref={modalRef}
          className="inline-block align-bottom bg-white dark:bg-stone-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="flex flex-col h-full">
            <div className="bg-white dark:bg-stone-900 pt-1 sm:pb-4 px-8 w-full flex-grow flex items-center justify-center">
              <div className="sm:flex sm:items-center">
                <div className="text-center sm:text-left">
                  <div className="flex justify-between items-center py-2">
                    <h2 className="text-lg font-bold dark:text-gray-200">
                      Feedback
                    </h2>
                    <button onClick={onClose}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-gray-600 hover:text-gray-800 dark:text-gray-500 dark:hover:text-gray-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="mt-2 dark:text-gray-300">{children}</div>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-stone-900 pb-8 px-7 sm:flex sm:flex-row-reverse justify-center">
              <button
                onClick={onClose}
                type="button"
                className="mt-1 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm py-2 text-base font-medium text-white bg-red-500 hover:bg-red-700 focus:outline-none sm:mx-1 sm:text-sm sm:mt-0"
              >
                Cancel
              </button>
              <button
                onClick={submit}
                className="mt-1 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:mx-1 sm:text-sm sm:mt-0 dark:bg-indigo-500 dark:hover:bg-indigo-600"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
